var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-nav"},[_c('div',{staticClass:"tab mt-3"},[_c('router-link',{staticClass:"tab-links p-3 hide-mobile",attrs:{"exact-active-class":"active","to":{name: 'mobile-login-v2'}}},[_vm._v("MOBILE APP")]),_c('router-link',{staticClass:"tab-links p-3",attrs:{"active-class":"active","to":{name: 'login-v2'}}},[_vm._v("LOGIN")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }